import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

const CollectionItem = (onClick: (id: string) => void, id: string) => {
  const { t } = useTranslation(TranslationContext.Settings);
  const windowWidth = window.innerWidth;

  const handleClick = useCallback(() => {
    if (!onClick) {
      return;
    }

    onClick(id);
  }, [onClick, id]);

  return { handleClick, windowWidth, t };
};

export default CollectionItem;
